import { Button } from "@/components/ui/button";
import { UserX } from "lucide-react";

interface SharedUserItemProps {
  email: string | null;
  sharedAt: string;
  onRevoke: () => void;
  isRevoking: boolean;
}

export function SharedUserItem({ email, sharedAt, onRevoke, isRevoking }: SharedUserItemProps) {
  return (
    <div className="flex items-center justify-between rounded-lg border p-2">
      <div>
        <p className="text-sm font-medium">{email}</p>
        <p className="text-xs text-muted-foreground">
          Shared on {new Date(sharedAt).toLocaleDateString()}
        </p>
      </div>
      <Button
        variant="ghost"
        size="sm"
        onClick={onRevoke}
        disabled={isRevoking}
      >
        <UserX className="h-4 w-4" />
        <span className="sr-only">Revoke access</span>
      </Button>
    </div>
  );
}